import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../Header';
import Footer from '../../Footer';
import LSGHero from './LSGHero';
import MainContent from './MainContent';
import LiquidityComponent from './Liquidity';
import SafetyComponent from './Safety';
import GrowthComponent from './Growth';
import LSGPractice from './LSGPractice.js';
import LSGFaqs from './LSGFaq';

const LSG = () => {
    const navigate = useNavigate();

    return (
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <LSGHero/>
          <MainContent />
          <LiquidityComponent />
          <SafetyComponent />
          <GrowthComponent />
          <LSGPractice />
          <LSGFaqs />
        </main>
        <Footer/>
      </div>
    );
  };

export default LSG;